module.exports = __webpack_public_path__ + "img/pager.e31f7603.png";